/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_TitleInputs */

const tr_landing_web_title = /** @type {(inputs: Landing_Web_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryerleri yetmez.`)
};

const en_landing_web_title = /** @type {(inputs: Landing_Web_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplaces alone are not enough.`)
};

const de_landing_web_title = /** @type {(inputs: Landing_Web_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplätze allein reichen nicht.`)
};

const ru_landing_web_title = /** @type {(inputs: Landing_Web_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одних маркетплейсов мало.`)
};

/**
* | output |
* | --- |
* | "Marketplaces alone are not enough." |
*
* @param {Landing_Web_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_title = /** @type {((inputs?: Landing_Web_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_title(inputs)
	if (locale === "de") return de_landing_web_title(inputs)
	if (locale === "ru") return ru_landing_web_title(inputs)
	return tr_landing_web_title(inputs)
});